module.exports = __webpack_public_path__ + "img/image2.ba6d9690.png";